import ace from "ace-builds";

const customTheme = {
  name: "custom-theme",
  isDark: true, // or false for a light theme
  cssClass: "ace-custom-theme",
  cssText: `
    @import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap');

    .ace-custom-theme {
        font-family: 'Source Code Pro', monospace !important;
    }

    .ace-custom-theme .ace_gutter {
        background: #2a2a2a;
        color: #ccc;
    }
    .ace-custom-theme .ace_print-margin {
        width: 1px;
        background: #555;
    }
    .ace-custom-theme {
        background-color:rgb(25, 25, 25);
        color: #f8f8f2;
    }
    .ace-custom-theme .ace_cursor {
        color: #f8f8f2;
    }
    .ace-custom-theme .ace_marker-layer .ace_selection {
        background: #44475a;
    }
    .ace-custom-theme .ace_keyword {
        color:rgb(255, 91, 184);
        font-weight: 900 !important;
        font-style: italic;
    }
    .ace-custom-theme .ace_string {
        color:rgb(255, 230, 44);
    }
    .ace-custom-theme .ace_comment {
        color:rgb(150, 150, 150);
    }

    .ace-custom-theme .ace_support.ace_constant,
    .ace-custom-theme .ace_support.ace_function {
        color: rgb(52, 205, 236);
        font-weight: 900 !important;
    }

    
    .ace-custom-theme .ace_marker-layer .ace_selected-word {
        border: 1px solid #49483E;
    }

    .ace-custom-theme .ace_invisible {
        color: #52524d;
    }

    .ace-custom-theme .ace_entity.ace_name.ace_tag,
    .ace-custom-theme .ace_keyword,
    .ace-custom-theme .ace_meta.ace_tag,
    .ace-custom-theme .ace_storage {
        color:rgb(255, 82, 146)
    }

    .ace-custom-theme .ace_punctuation,
    .ace-custom-theme .ace_punctuation.ace_tag {
        color: #fff;
    }

    .ace-custom-theme .ace_constant.ace_character,
    .ace-custom-theme .ace_constant.ace_language,
    .ace-custom-theme .ace_constant.ace_numeric,
    .ace-custom-theme .ace_constant.ace_other {
        color: rgb(193, 154, 255);
    }

    .ace-custom-theme .ace_invalid {
        color: #F8F8F0;
        background-color: #F92672;
    }

  `,
};

ace.define("ace/theme/tinacious-remix", ["require", "exports", "module"], function (require, exports, module) {
  module.exports = customTheme;
});
